'use client'

import React, { useState } from 'react'
// Deliberately shares the cockpit page's tab stylesheet rather than forking it:
// this band sits on the GT-2 Seat listing and has to read as the same component
// family as the GT-2 Cockpit compatibility band (same 1530px box, gutters, tab
// bar and spec rows).
import styles from '../GT2CockpitCheckoutPage/Gt2Tabs.module.css'

// VRS GT-2 Seat specs band. Content is hardcoded here, matching Gt2Compatibility
// — these are fixed product facts, not CMS copy, and keeping them in code stops
// the seat page and the cockpit page's "Supported seats" tab drifting apart.

const SPECS = [
  ['Size range', 'Fits users size L to XXL (up to 44 inch waist)'],
  ['Recommended user height', '120 – 230 cm (3 ft 11 in – 7 ft 7 in)'],
  ['Seat padding', '65 mm (2.5 inch) in the seating area'],
  ['Shell', 'Composite, minimum 6 mm (0.24 inch) thick'],
  ['Upholstery', 'Wear-resistant, breathable suede fabric'],
  ['Weight', '8 kg (17.6 lbs)'],
]

const SPECS_NOTE = 'Built for long stints rather than a tight competition fit. Composite bucket seats tend to run narrow and firm; the GT-2 Seat carries 65 mm (2.5 inch) of padding in the seating area so it stays comfortable across a full endurance race.'

const FIT_LEAD = 'Mounts to the VRS GT-2 chassis, and to any rig with side brackets in this range.'

const FIT = [
  ['Side distance between seat mounting points (min/max)', '285 – 295 mm (11.2 – 11.6 inch)'],
  ['Seat width at mounting points (min/max)', '390 – 520 mm (15.3 – 20.5 inch)'],
  ['Mounting points', 'M8'],
  ['Angle adjustment', 'Tilt 0 – 18°'],
]

const TABS = [
  { id: 'specs', label: 'Seat specifications', specs: SPECS, note: SPECS_NOTE },
  { id: 'fit', label: 'Fit & mounting', lead: FIT_LEAD, specs: FIT },
]

function Gt2SeatSpecs() {
  const [tab, setTab] = useState('specs')
  const active = TABS.find((t) => t.id === tab) || TABS[0]

  return (
    <section className={styles.wrap} aria-label="VRS GT-2 Seat specifications">
      <div className={styles.inner}>
        <h2 className={styles.heading}>VRS GT-2 Seat Specifications</h2>
        <div className={styles.tabs} role="tablist">
          {TABS.map((t) => (
            <button
              type="button"
              key={t.id}
              role="tab"
              aria-selected={active.id === t.id}
              className={[styles.tab, active.id === t.id && styles.tabActive].filter(Boolean).join(' ')}
              onClick={() => setTab(t.id)}
            >
              {t.label}
            </button>
          ))}
        </div>
        <div className={styles.panel} role="tabpanel">
          <div className={styles.specBlock}>
            {active.lead && <p className={styles.lead}>{active.lead}</p>}
            <ul className={styles.specList}>
              {active.specs.map(([label, value]) => (
                <li className={styles.specRow} key={label}>
                  <span className={styles.specLabel}>{label}</span>
                  <span className={styles.specValue}>{value}</span>
                </li>
              ))}
            </ul>
            {active.note && <p className={styles.seatNote}>{active.note}</p>}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Gt2SeatSpecs
